export default __webpack_public_path__ + "media/images/seestadt-aspern-D9-99173d8604d523c99e04c9672745638e.jpg";